import { setElementVisible } from '../../../../shared/DOM/setElementVisible.js';

export function renderViewDocsWorkflow(tokena, viewdocsData) {
  // Misma lógica que en login
  sessionStorage.setItem('tokena', tokena);

  setElementVisible(document.getElementById('section-viewdocs'), false);

  const eSection = document.getElementById('section-component');
  eSection.innerHTML = getComponentTemplate(viewdocsData);
  setElementVisible(eSection, true); // Podemos venir de un error: aseguramos el visible
}

function getComponentTemplate({ uuid, idVol, pa, form, preview, printOtpRequired, dprint, seccode, reference, schema, header, icon }) {
  // Podemos tener seccode por el registerSession (lo omitiríamos en ese caso)
  const printOtpToken = printOtpRequired ? seccode : '';
  const label = getComponentLabel(header, schema, reference);
  const attPreview = preview ? 'preview' : '';
  const attDprint = dprint ? 'dprint' : '';

  return `<view-docs-workflow uuid="${uuid || ''}" id-vol="${idVol || ''}" filter="${pa || ''}" form-id="${form || 1}" seccode="${printOtpToken || ''}" icon="${
    icon || 'file-signature'
  }" label="${label}" ${attPreview} ${attDprint}></view-docs-workflow>`;
}

function getComponentLabel(header, schema, reference) {
  return `${header || edicom.locale.translate('grid.checkAndSign')} | ${schema || 'XML_BMPAYROLL'} · ${reference || '-'}`;
}
